"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardComparisonContainer_1 = require("./CardComparisonContainer");
exports.default = CardComparisonContainer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/index.js
// module id = 1304
// module chunks = 8